import dynamic from 'next/dynamic';
import { ReservationRoomImageProps } from './ReservationRoomImage.types';

export const ReservationRoomImage = dynamic<ReservationRoomImageProps>(() =>
  import('./ReservationRoomImage').then(module => module.ReservationRoomImage)
);
